/**
 * Authentication configuration for JWT Bearer Token authentication
 */
export const authConfig = {
  /**
   * API endpoints for authentication
   */
  endpoints: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/dashboard/users/me',
    googleAuthRedirect: '/auth/google/redirect',
    googleAuthCallback: '/auth/google/callback',
  },

  /**
   * Token configuration
   */
  tokens: {
    accessTokenKey: 'fl_access_token',
    refreshTokenKey: 'fl_refresh_token',
    tokenDataKey: 'fl_token_data',
  },

  /**
   * Get the API base URL
   */
  getApiUrl: (): string => {
    return import.meta.env.VITE_GOOGLE_OAUTH_API_URL || 'https://api.fluenceur.com';
  },
};
